<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  watch: {
    created () {
      this.setIsPhoneModalVisible(false)
      this.setIsMeetingModalVisible(false)
    }
  },

  computed: {
    ...mapGetters({
      isMeetingModalVisible: 'excmrelation/createModal/getIsMeetingModalVisible',
      isPhoneModalVisible: 'excmrelation/createModal/getIsPhoneModalVisible',
      created: 'excmrelation/create/created'
    })
  },

  methods: {
    ...mapMutations({
      setIsPhoneModalVisible: 'excmrelation/createModal/setIsPhoneModalVisible',
      setIsMeetingModalVisible: 'excmrelation/createModal/setIsMeetingModalVisible'
    }),
    ...mapActions({
      reset: 'excmrelation/create/reset'
    }),
    onSendForm () {
      let item = Object.assign({}, this.item)
      this.create(item)
    },
    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
